import { AppComponent, SafePipe } from './app.component';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabase } from 'angularfire2/database';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, Location, LocationStrategy } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { GoogleChartsModule } from 'angular-google-charts';

import { AdvertisementsService } from '../common/services/advertisements.service';
import { AgendaComponent } from './agenda/agenda.component';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { AppStore } from '../common/stores/app.store';
import { AssetsService } from '../common/services/assets.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Bus } from '../common/services/bus';
import { CountdownTimerModule } from 'ngx-countdown-timer';
import { EmbededUrlPipe } from '../common/pipes/embeded-url';
import { environment } from '../environments/environment';
import { FramesComponent } from './frames/frames.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MessagesService } from '../common/services/messages.service';
import { MessagesResolverService } from '../common/services/messages-resolver.service';
import { MockService } from '../common/services/mock.service';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { NotificationsService } from '../common/services/notifications.service';
import { RouteResolverService } from '../common/services/route-resolver.service';
import { SettingsService } from '../common/services/settings.service';
import { SetupComponent } from './setup/setup.component';
import { SlideshowModule } from 'ng-simple-slideshow';
import { SpeakersComponent } from './speakers/speakers.component';
import { SponsorsComponent } from './sponsors/sponsors.component';
import { ToastrModule } from 'ngx-toastr';
import { VideoOverlayComponent } from './video-overlay/video-overlay.component';

const appRoutes: Routes = [

  { path: 'agenda', component: AgendaComponent },
  { path: 'frames', component: FramesComponent, resolve: { messages: MessagesResolverService} },
  { path: 'frames/:id', component: FramesComponent },
  { path: 'speakers', component: SpeakersComponent },
  { path: 'sponsors', component: SponsorsComponent },
  { path: 'setup', component: SetupComponent },
  // { path: '', component: RoomsComponent },
  { path: '**', redirectTo: 'setup', pathMatch: 'full' }
];

@NgModule({
  declarations: [
    AgendaComponent,
    AppComponent,
    FramesComponent,
    SetupComponent,
    SafePipe,
    EmbededUrlPipe,
    SpeakersComponent,
    SponsorsComponent,
    VideoOverlayComponent
  ],
  imports: [
    AngularFontAwesomeModule,
    AngularFireModule.initializeApp(environment.firebase),
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    CountdownTimerModule.forRoot(),
    HttpClientModule,
    MatDialogModule,
    SlideshowModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-full-width',
      autoDismiss: false
    }),
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true } // <-- debugging purposes only
    ),
    GoogleChartsModule
  ],
  entryComponents: [
    VideoOverlayComponent
  ],
  providers: [
    AngularFireDatabase,
    AdvertisementsService,
    AppStore,
    AssetsService,
    MessagesService,
    MessagesResolverService,
    MockService,
    NotificationsService,
    SettingsService,
    Location,
    // Add /#/ in the URL
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    Bus,
    { provide: APP_INITIALIZER, useFactory: setParams, deps: [RouteResolverService], multi: true },
    RouteResolverService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function setParams(routeResolver: RouteResolverService) {
  return () => routeResolver.load();
}
